module.exports = __webpack_public_path__ + "img/startpageImage.132ebe66.jpg";